import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import ApplicationAPI from 'api/Application';
import { ERROR_CODES, ERROR_DETAIL_CODES } from 'api/constants';
import { CommonErrorResponse } from 'api/httpService';
import {
  setIsDataNotMatchError,
  setModalErrorOpen,
} from 'app/domain/loan/slice';
import { QueryKeys } from 'reactQuery/queryKeys';
import store from 'store/configureStore';

const useGetApplicationDetail = (applicationId: string) =>
  useQuery(
    [QueryKeys.applicationDetail],
    () =>
      ApplicationAPI.getApplicationDetail(applicationId)
        .then(response => response.data)
        .catch((err: AxiosError<CommonErrorResponse>) => {
          const isDataNotMatch =
            err.response?.status === ERROR_CODES.BAD_REQUEST &&
            err.response?.data?.code ===
              ERROR_DETAIL_CODES.NOT_MATCH_DATA_CUSTOMER;

          if (isDataNotMatch) {
            store.dispatch(setIsDataNotMatchError());
          }
          store.dispatch(setModalErrorOpen());
          throw new Error(err.message);
        }),
    {
      enabled: !!applicationId,
    },
  );

export default useGetApplicationDetail;
